import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from 'syf-component-library/ui/spacing';
import Body from 'syf-component-library/ui/typography/Body';
import { fontSizes } from 'syf-component-library/defaultTheme';
import { FAS_CIRCLE_EXCLAMATION, FAS_CIRCLE_INFO, FAS_EXCLAMATION_TRIANGLE } from '../const';
import { Icon } from './icon';
import { MessageBoxSyf } from './subcomponents';
const ICONS_BY_TYPE = {
    info: {
        icon: FAS_CIRCLE_INFO,
        title: 'info circle icon',
        style: { fontSize: `${fontSizes.medium}px`, margin: '2px' }
    },
    error: {
        icon: FAS_EXCLAMATION_TRIANGLE,
        title: 'error exclamation triangle icon',
        style: { fontSize: `${fontSizes.large}px` }
    },
    warning: {
        icon: FAS_CIRCLE_EXCLAMATION,
        title: 'warning exclamation circle icon',
        style: { fontSize: `${fontSizes.medium}px`, margin: '2px' }
    }
};
export const MessageBox = ({ icon, iconColor, iconTitle, messageDescription, messageDescriptionHighlighted, messageSubDescription, messageTitle, type }) => {
    return (_jsxs(MessageBoxSyf, { "data-cy": "message-box", type: type, icon: _jsx(Icon, { color: iconColor, icon: icon || ICONS_BY_TYPE[type].icon, style: ICONS_BY_TYPE[type].style, title: iconTitle || ICONS_BY_TYPE[type].title }), children: [messageTitle && _jsx(Body, { weight: "bold", children: messageTitle }), messageTitle && _jsx(Stack, { size: "xsmall" }), messageDescription && (_jsxs(Body, { children: [messageDescription, messageDescriptionHighlighted && (_jsx(Body, { isInline: true, weight: "bold", children: messageDescriptionHighlighted }))] })), messageSubDescription && _jsx(Stack, {}), messageSubDescription && _jsx(Body, { children: messageSubDescription })] }));
};
